import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { DefaultPlanForm } from "../DefaultPlanForm";
import { EditDefaultPlanModalProps } from "./types";
import { useEditDefaultPlanModal } from "./controller";

export const EditDefaultPlanModal = React.memo(
  ({ modalRef, onComplete }: EditDefaultPlanModalProps) => {
    const translate = useTranslate();

    const { methods, handleSubmit, isPending } =
      useEditDefaultPlanModal(modalRef, onComplete);

    return (
      <Modal
        ref={modalRef}
        title={translate("default_plan_admin.titles.edit")}
        onConfirm={handleSubmit}
        methods={methods}
        isPending={isPending}
      >
        <DefaultPlanForm />
      </Modal>
    );
  }
);
